import TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './documentEditor.html?raw';

import * as docTypes from "./documentEditorTypes";

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

import * as SyncfusionHelper from "../../../moreCore/Tools/syncfusionHelper";
import { ExtraHelpers } from "../../../more/Helpers";


class documentEditor extends compose(TabEnabledMixin) {
    templateString: any = template;

    public config: docTypes.documentConfiguration = {
        modules: {
            enablePrint: true,
            enableSfdtExport: true,
            enableSelection: true,
            enableSearch: true,
            enableWordExport: false,
            enableTextExport: false,
            enableEditor: true,
            enableEditorHistory: false,
            enableOptionsPane: true,
            enableContextMenu: true,
            enableHyperlinkDialog: true,
            enableImageResizer: true,
            enableTableDialog: true,
            enableFontDialog: true,
            enableParagraphDialog: true,
            enableBookmarkDialog: true,
            enablePageSetupDialog: true,
            enableTableOfContentsDialog: true,
            enableListDialog: true,
            enableTablePropertiesDialog: true,
            enableBordersAndShadingDialog: true,
            enableStylesDialog: true,
            enableStyleDialog: true,
            enableBulletsAndNumberingDialog: true,
            enableTableOptionsDialog: true,
            enableCellOptionsDialog: true,
        },
        toolbarItems: {
            "New": false,
            "Open": false,
            "Separator": true,
            "Undo": true,
            "Redo": true,
            "Image": true,
            "Table": true,
            "Hyperlink": true,
            "Bookmark": true,
            "TableOfContents": true,
            "Header": true,
            "Footer": true,
            "PageSetup": true,
            "PageNumber": true,
            "Break": true,
            "InsertFootnote": true,
            "InsertEndnote": true,
            "Find": true,
            "Comments": true,
            "TrackChanges": true,
            "LocalClipboard": false,
            "RestrictEditing": false,
            "FormFields": true,
            "UpdateFields": true,
            "ContentControl": true
        },
        isReadOnly: false,
        enableToolBar: true,
        showSaveButton:false,
    };

    private documentEditorWidget: docTypes.documentEditorContainer;

    private mainContainer: HTMLDivElement;
    private docEditId: string;
    public isReady: boolean = false;

    private documentAuthor: string = "";
    private sourceKeyVtFiles: string;

    public dlg:MdsLax<InstanceType<typeof GenericDialog>>; //absichtlich auf public, weil imo getter Methode waere auch bissl unnoettig

    private flag_blockForceResizeEvent = false; //recrusive hell in re-size event wegen observer...
    private flag_dlgClosed = false;
    private connectObserverTimeout: number = null;
    private boundForceResize: () => void = null;

    private async initDependencys(callback: Function) {
        await Promise.allSettled([
            ExtraHelpers.sideLoadResource(SyncfusionHelper.getSfLangScriptPath(), 'js'),
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/syncfusion/docEditor/scripts/ej2.js", 'js' ),
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/syncfusion/docEditor/styles/material.css", 'css' ),
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/syncfusion/docEditor/styles/customized/material.css", 'css' ),
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/syncfusion/docEditor/styles/material-dark.css", 'css' ),
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/syncfusion/docEditor/styles/customized/material-dark.css", 'css' )
        ]);
        if (typeof callback == 'function') {
            callback();
        }
    }
    postCreate(): void {
        this.initDependencys(lang.hitch(this, this.postCreate_continue));
    }

    destroy(preserveDom?: boolean): void {
        try {
            if (this.connectObserverTimeout != null) {
                clearTimeout(this.connectObserverTimeout);
            }
        } catch { }
        try{
            clearTimeout(this.layoutMobileFixTimeout);
        }catch{}
        try{
            if (typeof this.resizeObs != 'undefined'){
                this.resizeObs.disconnect();
                this.resizeObs = undefined;
            }
        }catch{}
        try{
            if (this.boundForceResize != null){
                window.removeEventListener('resize', this.boundForceResize);
                this.boundForceResize = null;
            }
        }catch{}
        try{
            //SyncFusion DocumentEditorContainer muss explizit zerstoert werden, sonst leakt der interne
            //ResizeObserver und erzeugt beim naechsten Oeffnen einen "ResizeObserver loop"-Fehler
            if (this.documentEditorWidget != null && typeof (this.documentEditorWidget as any).destroy == 'function'){
                (this.documentEditorWidget as any).destroy();
                this.documentEditorWidget = null;
            }
        }catch(e){
            console.warn("documentEditor: failed to destroy SyncFusion container", e);
        }
    }

    private postCreate_continue() {
        this.docEditId = this.id + "_" + String(new Date().valueOf());
        this.mainContainer.id = this.docEditId;


        if (SyncfusionHelper.loadLicense(this.getModule("Webcalendar")["license"]) == false) {
            this.showToast(this.translate["SyncfusionLicenseError"], "fas fa-bug");
        }
        if (SyncfusionHelper.loadLanguage() == false) {
            console.error("syncfusionhelper: can't load translation");
            this.showToast("Syncfusion: can't load translation", "fas fa-bug");
        }

        this.isReady = true;
        this.emit("ready");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public async openDocument(sfdtString: string, skipSfdtCheck=false, openAsDlg=false) {
        this.StandbyStart();
        if (openAsDlg == true){
            this.dlg = new GenericDialog();
            this.dlg.closeOnEnter = false;
            this.dlg.closeOnEscape = false;
            this.dlg.setSize('fullsize');
            this.dlg.show(
                this,
                this.translate("DocumentEditor_DlgHeader"),
                null,
                null,
                'saveclose',
                lang.hitch(this, (res:number)=>{
                    this.flag_dlgClosed = true;
                    this.emit("dlgClosed", res);
                    if (res == 1){
                        this.emit("dlgClosedSaved");
                    }
                    if (res == 0){
                        this.emit("dlgClosedClose");
                    }
                })
            );
            this.dlg._setTopCloseBtnAttr(false);
        }
        if (skipSfdtCheck == false) {
            if (this.helper_isSTDF(sfdtString) == false) {
                this.showToast("error: can't load document", "fas fa-bug");
                console.error("invalid sfdt format, can't be loaded by document editor");
                return;
                //throw "this sfdt document is probably invalid and can't be loaded!";
            }
        }
        await this.waitForReady();
        let initObj = {
            enableToolbar: this.config.enableToolBar,
            isReadOnly: this.config.isReadOnly,
            width: "100%",
            height: "100%",
            enableTrackChanges:true,
        };
        for (let option in this.config.modules) {
            if (typeof this.config.modules[option] == 'boolean') {
                initObj[option] = this.config.modules[option];
            }
        }
        let defaultToolbarItems = [
            'New', 'Open', 'Separator', 'Undo', 'Redo',
            'Separator', 'Image', 'Table', 'Hyperlink',
            'Bookmark', 'TableOfContents', 'Separator',
            'Header', 'Footer', 'PageSetup', 'PageNumber',
            'Break', 'InsertFootnote', 'InsertEndnote',
            'Separator', 'Find', 'Separator', 'Comments',
            'TrackChanges', 'Separator', 'LocalClipboard',
            'RestrictEditing', 'Separator', 'FormFields',
            'UpdateFields', 'ContentControl'];
        let usedToolbarItems = [];
        for (let item of defaultToolbarItems) {
            if (typeof this.config.toolbarItems[item] == 'boolean') {
                if (this.config.toolbarItems[item] == true) {
                    usedToolbarItems.push(item);
                }
            }
        }
        initObj["toolbarItems"] = usedToolbarItems;
        if (this.config.showSaveButton == true){
            let saveBtn = {
                prefixIcon: "e-save icon pdfEditorSaveIconColorUnsaved",
                id:"saveBtn",
                tooltipText: this.translations["General_Save"],
                text: this.translations["General_Save"],
                align: 'Left',
            }
            initObj["toolbarItems"].push(saveBtn);
            this.on("saveDocument", lang.hitch(this, this.saveDocument));
        }

        initObj["enableSfdtExport"] = true;
        initObj["enableWordExport"] = true;
        initObj["enableTextExport"] = true;
        initObj["locale"] = "default_fallback";

        window["ej"]["documenteditor"]["DocumentEditor"]["Inject"](window["ej"]["documenteditor"]["SfdtExport"]);

        this.documentEditorWidget = new window["ej"]["documenteditor"]["DocumentEditorContainer"](initObj);
        this.documentEditorWidget.acceptTab = true;
        this.documentEditorWidget.autoResizeOnVisibilityChange = true;

        this.documentEditorWidget.enableAutoFocus = false; //weil besser fuer accessibility/screenreader und so...
        this.documentEditorWidget.enableTrackChanges = true;
        this.documentEditorWidget.appendTo("#" + this.docEditId);
        try{
            this.documentEditorWidget.documentEditor.open(sfdtString);
        }catch(err){
            console.error(err);
            if (this.domNode.isConnected == false) {
                console.error("stelle bitte sicher, dass das widget im dom vorhanden ist");
            }
            return;

        }
        this.addEventHooks();
        this.documentEditorWidget.currentUser = this.documentAuthor;
        if (this.config.isReadOnly == true){
            this.documentEditorWidget.enableToolbar = false;
        }

        if (typeof this.resizeObs != 'undefined'){
            this.resizeObs.disconnect();
            this.resizeObs.observe(this.domNode);
        }else{
            this.connectObserverTimeout = setTimeout(()=>{
                this.resizeObs = new ResizeObserver(lang.hitch(this, this.forceResize));
                this.resizeObs.observe(this.domNode);
                this.boundForceResize = this.forceResize.bind(this);
                window.addEventListener('resize', this.boundForceResize);
                this.connectObserverTimeout = null;
            }, 10); //weil race condition mit generic dlg YAY
        }
        if (this.config.isReadOnly == true){
            this.domNode.classList.add("documentEditorReadOnly");
        }
        this.documentEditorWidget.restrictEditing = this.config.isReadOnly;

        //ab einer gewissen window breite macht es sinn, das text edit feld beim laden geschlossen zu haben und wenn genug platz ist es automatisch zu oeffnen
        if (this.domNode.getBoundingClientRect().width < 1130) {
            this.documentEditorWidget.showPropertiesPane = false;
            this.layoutMobileFixTimeout = setTimeout(lang.hitch(this, this.layout_and_mobile_fix), 50); //timeout weil es ansonsten zu render bugs kommen kann wenn wir zu frueh zeug wegschalten
        } else {
            this.documentEditorWidget.showPropertiesPane = true;
        }

        this.StandbyStop();
    }

    private layoutMobileFixTimeout:number;
    private layout_and_mobile_fix(){
        //"fix" https://help.syncfusion.com/document-processing/word/word-processor/javascript-es5/how-to/deploy-document-editor-component-for-mobile
        if (this.domNode.getBoundingClientRect().width < 1130){
            this.documentEditorWidget.documentEditor.commentReviewPane.closePane();
            this.documentEditorWidget.documentEditor.fitPage('FitPageWidth');
            if (this.domNode.getBoundingClientRect().width < this.domNode.getBoundingClientRect().height){ //mobile?
                this.documentEditorWidget.documentEditor.fitPage('FitPageWidth')
            }
        }
    }

    private resizeObs:ResizeObserver;

    private addEventHooks(){
        this.documentEditorWidget.beforeAcceptRejectChanges = lang.hitch(this, (ev: any) => {
            this.emit("beforeAcceptRejectChanges", ev);
        });
        this.documentEditorWidget.beforeCommentAction = lang.hitch(this, (ev: any) => {
            this.emit("beforeCommentAction", ev);
        });
        this.documentEditorWidget.beforePaneSwitch = lang.hitch(this, (ev: any) => {
            this.emit("beforePaneSwitch", ev);
        });
        this.documentEditorWidget.commentDelete = lang.hitch(this, (ev: any) => {
            this.emit("commentDelete", ev);
        });
        this.documentEditorWidget.documentEditor.contentChange = lang.hitch(this, (ev: any) => {
            this.emit("contentChange", ev);
        });
        this.documentEditorWidget.contentControl = lang.hitch(this, (ev: any) => {
            this.emit("contentControl", ev);
        });
        this.documentEditorWidget.created = lang.hitch(this, (ev: any) => {
            this.emit("documentEditorCreated", ev);
        });
        this.documentEditorWidget.customContextMenuBeforeOpen = lang.hitch(this, (ev: any) => {
            this.emit("customContextMenuBeforeOpen", ev);
        });
        this.documentEditorWidget.customContextMenuSelect = lang.hitch(this, (ev: any) => {
            this.emit("customContextMenuSelect", ev);
        });
        this.documentEditorWidget.destroyed = lang.hitch(this, (ev: any) => {
            this.emit("destroyed", ev);
        });
        this.documentEditorWidget.documentEditor.documentChange = lang.hitch(this, (ev: any) => {
            this.emit("documentChange", ev);
        });
        this.documentEditorWidget.selectionChange = lang.hitch(this, (ev: any) => {
            this.emit("selectionChange", ev);
        });
        /*
        this.documentEditorWidget.serviceFailure = lang.hitch(this, (ev: any) => {
            this.emit("serviceFailure", ev);
        }); //NOTE - nur relevant wenn es eine server komponente gibt
        */
        this.documentEditorWidget.toolbarClick = lang.hitch(this, (ev: any) => {
            this.emit("toolbarClick", ev);
            switch (ev.item.id){
                case 'saveBtn':
                    this.emit("saveDocument");
                    break;
            }
        });
        this.documentEditorWidget.trackChange = lang.hitch(this, (ev: any) => {
            this.emit("trackChange", ev);
        });
    }

    private async waitForReady(){
        //wir warten hier bis wir bereit sind das dokument zu laden
        await this.loadAuthorName();
        if (this.isReady == true){ //wenn bereits ready dann brauchen wir auch nicht warten
            return; //kann evtl. passieren wenn dependencys schoneinmal geladen wurde
        }
        await new Promise((resolve)=>{
            this.checkInterval = setInterval(()=>{
                if (this.isReady == true){
                    clearInterval(this.checkInterval);
                    resolve(true);
                }
            }, 2000);
        });
    }
    private checkInterval:number;
    private async loadAuthorName() {
        this.documentAuthor = await new Promise((resolve) => {
            this.getCurrentUserName((username: string) => {
                resolve(username);
            });
        });
        if ((this.documentAuthor == null) || (this.documentAuthor == "") || (typeof this.documentAuthor != 'string')) {
            this.documentAuthor = "Guest";
        }
    }

    public loadDocumentByKey(vt_files_key:string){
        this.config.showSaveButton = true;
        this.sourceKeyVtFiles = vt_files_key;
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_SyncfusionDocumentEditor__RetrieveSfdt",
            {
                file_id:vt_files_key,
                request_format:"sfdt",//hardcoded im moment, eigentlich nur da, falls in zukunft sfdt wegfaellt und ersetzt wird
            },
            lang.hitch(this, this._loadDocumentByKey_Response),
            lang.hitch(this, (err)=>{
                console.error(err.Message);
                this.showToast(err.Message, "fas fa-bug");
            })
        );
    }

    private _loadDocumentByKey_Response(res:{base64File:string, fileFormat:string}){
        this.StandbyStop();
        if (res.fileFormat != "sfdt"){
            console.error("unknown file format", res);
            this.showToast(this.translations["General_Error"]);
            return;
        }
        this.openDocument(atob(res.base64File), false);
    }

    public async exportAsSfdt(){
        let sfdtBlob: Blob = await this.documentEditorWidget.documentEditor.saveAsBlob("Sfdt");
        this.emit("saveDocumentFinished", sfdtBlob);
        let sfdtString:string = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result as string);
            };
            reader.onerror = (err) => {
                reject(err);
            };
            reader.readAsText(sfdtBlob);
        });
        return sfdtString;
    }
    private async saveDocument(){
        this.StandbyStart();
        let sfdtText:string = await this.exportAsSfdt();

        if (typeof this.sourceKeyVtFiles != 'string'){
            this.StandbyStop();
            return;
        }
        if (typeof sfdtText != 'string'){
            this.StandbyStop();
            return;
        }

        this.RequestManager.callfunction(
            "Webtool_API_SyncfusionDocumentEditor__OverwriteSfdt",
            {
                fileDataBase64: btoa(sfdtText),
                vt_file_id: this.sourceKeyVtFiles,
            },
            lang.hitch(this, this.saveDocument_callback),
            lang.hitch(this, (err)=>{
                this.StandbyStop();
                console.error(err);
                this.showToast(this.translations["General_SavingFailed"] + err.Message, "fas fa-exclamation-triangle");
            })
        );
    }

    private saveDocument_callback(res:any){
        this.StandbyStop();
        console.info("overwrite sharepoint item", res);
        this.showToast(this.translations["General__SaveSuccess"], "far fa-check-circle");
    }

    public loadDocumentByBase64(fileBase64Content: string, filetype: string){
        this.RequestManager.callfunction(
            "Webtool_API_SyncfusionDocumentEditor__FreeConvertDocument",
            {
                source_ext: filetype.replace(".", ""),
                target_ext: "SFDT",
                base64Content: fileBase64Content,
            },
            lang.hitch(this, this.loadDocumentByBase64_callback),
            lang.hitch(this, (err)=>{
                console.error(err);
                this.showToast(this.translations["General_Error"] + ":" + err.Message, "fas fa-exclamation-triangle");
            })
        );
    }

    private loadDocumentByBase64_callback(res: { base64Content:string, ext:string}){
        if (res.ext.toLocaleLowerCase() == "sfdt"){
            this.openDocument(atob(res.base64Content));
        }else{
            console.error("unsported format", res);
            this.showToast(this.translations["email_onError_unknownError"], "fas fa-bug");
        }
    }

    /**
     * Helfer Methode um zu testen ob ein String ein Stdf Dokument sein kann, es kann troz check noch zu Fehler beim Laden vom Dokument kommen...
    */
    public helper_isSTDF(stringToText:string){
        let testStr:string = stringToText.trim();
        if ( (testStr.charAt(0) != "{") && (testStr.charAt(testStr.length - 1) != "}") ){
            return false;
        }
        try{
            JSON.parse(testStr);
        }catch{
            return false;
        }
        return true;
    }

    /**
     * Erwzingt das Re-sizen vom DocumentEditor iframe.
     * Es wird versucht den Container im Widget auszufuellen (class="documentEditorWidgetContainer").
     */
    public forceResize(){
        if (typeof this.flag_blockForceResizeEvent != 'undefined'){
            if (this.flag_blockForceResizeEvent == true){
                return; //early exit wegen recrusive call
            }
        }
        if (this.flag_dlgClosed == true){
            return;
        }
        if (typeof this.domNode != 'undefined'){
            if (this._destroyed != true){
                if (typeof this.domNode.isConnected != 'undefined'){
                    if (this.domNode.isConnected){
                        let rect = this.domNode.getBoundingClientRect();
                        let h = rect.height;
                        let w = rect.width;
                        if ((h > 200) && (w > 200)){ //document editor selber checkt nach min werte, aber fuer optimierungen machen wir es hier auch...
                            this.flag_blockForceResizeEvent = true;
                            this.documentEditorWidget.resize(w, h);
                            this.flag_blockForceResizeEvent = false;
                        }
                    }
                }
            }
        }
    }
}

export default mdsWidget(documentEditor);
